<nz-alert
    [nzBanner]="appLevel"
    [nzCloseable]="!hideCloseButton"
    [nzMessage]="message"
    [nzType]="alertType"></nz-alert>
